module.exports = __webpack_public_path__ + "static/media/inc_infected_fisdom.4801c8fd.svg";